import React, { useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { useAuth } from '../AuthContext';
import { apiUrl } from '../config/apiBase';
import './Feedback.css';

const Feedback = () => {
  const { user, refreshTokenIfNeeded } = useAuth();
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) {
      alert('Please select a rating');
      return;
    }

    setLoading(true);

    try {
      const token = await refreshTokenIfNeeded();
      const userId = user?.id;
      const userEmail = user?.email;

      const response = await fetch(apiUrl('/api/feedback'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: userId,
          email: userEmail,
          rating,
          comment,
        }),
      });

      if (response.ok) {
        setSubmitted(true);
        setRating(0);
        setComment('');
        setTimeout(() => setSubmitted(false), 3000);
      } else {
        alert('Failed to submit feedback');
      }
    } catch (error) {
      console.error('Error submitting feedback:', error);
      alert('Error submitting feedback');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="feedback-container">
        <div className="feedback-success">
          <h3>Thank you for your feedback!</h3>
          <p>Your input helps us improve LeetEngineer.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="feedback-container">
      <h3>Share Your Feedback<br /> <span>More Feedback helps LeetEngineer to create the best experience with AI-powered resume building and interview preparation for you.</span></h3>
      <form onSubmit={handleSubmit}>
        <div className="feedback-form">
          <div className="rating-section">
            <label>Rating:</label>
            <div className="stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                  key={star}
                  className="star"
                  color={star <= (hover || rating) ? '#ffc107' : '#e4e5e9'}
                  size={30}
                  onMouseEnter={() => setHover(star)}
                  onMouseLeave={() => setHover(0)}
                  onClick={() => setRating(star)}
                />
              ))}
            </div>
          </div>
          <div className="comment-section">
            <label>Your concerns or suggestions:</label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Tell us what you think..."
              rows={4}
              required
            />
          </div>
        </div>
        <div className="submit-section">
          <button
            type="submit"
            className="submit-feedback-btn"
            disabled={loading || rating === 0}
          >
            {loading ? 'Submitting...' : 'Submit Feedback'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Feedback;
